import React from 'react'
import { Typography } from '@mui/material'
import { getGridStringOperators } from '@mui/x-data-grid-pro'

import { BaseColumnType } from '../types/types'

export const emailColumnModel: BaseColumnType = {
  field: 'email',
  flex: 1,
  filterOperators: getGridStringOperators().filter((operator) => operator.value === 'contains' || operator.value === 'equals'),
  renderCell: (params) => (
    <Typography variant="subtitle1" fontWeight={500}>{params.value}</Typography>
  )
}
